export default "__VITE_ASSET__kaxC8qFG__"